var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDontblink(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 244,
    height: 211,
    viewBox: "0 0 244 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.712 92.4555C128.948 91.7406 127.749 91.7847 127.034 92.5486C127.034 92.5486 77.4308 144.783 78.5 146C79.6558 147.308 129.805 95.1335 129.805 95.1335C130.513 94.3673 130.476 93.1704 129.712 92.4555Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.527 79.3493C114.763 78.6345 113.564 78.6786 112.849 79.4425C112.849 79.4425 43.2184 153.601 44.2877 154.818C45.4435 156.127 115.62 82.0274 115.62 82.0274C116.328 81.2612 116.291 80.0642 115.527 79.3493Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.8544 123.163C92.3901 123.768 124.787 89.5588 124.787 89.5588C125.114 89.2085 125.094 88.6547 124.744 88.3273C124.394 88 123.84 88.0196 123.513 88.3698C123.505 88.3675 91.3619 122.604 91.8544 123.163Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.724 88.3985C116.374 88.0712 115.82 88.0908 115.493 88.441C115.493 88.441 83.3497 122.678 83.8422 123.236C84.3779 123.841 116.774 89.6322 116.774 89.6322C117.102 89.282 117.082 88.7281 116.724 88.3985Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.247 76.5982C110.574 76.248 110.555 75.6941 110.204 75.3668C109.854 75.0394 109.3 75.0591 108.973 75.4093C108.973 75.4093 76.8297 109.646 77.3221 110.205C77.8429 110.805 110.247 76.5982 110.247 76.5982Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.634 64.4338C123.218 64.4983 124.793 64.7486 126.33 65.1832C126.378 64.969 126.425 64.7624 126.489 64.5528C128.228 58.8339 134.271 55.6099 139.99 57.3495C145.709 59.0891 148.933 65.132 147.193 70.8508C146.107 74.4214 143.337 77.0217 140.025 78.0425C140.927 80.6149 141.311 83.3323 141.158 86.0416L159.484 65.5037L137.884 46.2328L121.634 64.4338Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.24 63.9639L138.958 42.2988L137.879 46.2231L159.479 65.494L163.26 63.9782L163.24 63.9639Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.869 69.1491L109.403 70.7966L111.139 70.7606L111.301 72.4864L113.038 72.4503L113.197 74.1836L114.934 74.1475L115.096 75.8733L116.833 75.8372L116.995 77.563L118.729 77.5344L118.891 79.2602L120.627 79.2241L120.787 80.9574L122.524 80.9213L122.686 82.6471L124.422 82.6111L124.589 84.3466L126.326 84.3105L126.488 86.0363L128.222 86.0077L128.384 87.7335L130.121 87.6975L130.283 89.4232L132.017 89.3947L132.186 91.1227L133.923 91.0867L134.083 92.8199L135.819 92.7839L135.981 94.5096L137.455 92.8643L113.173 71.1993L110.869 69.1491Z",
    fill: "#EF484F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 42.2987L163.24 63.9638L164.706 62.3162L162.977 62.3545L162.808 60.6264L161.081 60.6573L160.911 58.9292L159.175 58.9653L159.013 57.2395L157.279 57.2681L157.117 55.5423L155.38 55.5784L155.218 53.8526L153.484 53.8812L153.322 52.1554L151.585 52.1915L151.423 50.4657L149.689 50.4942L149.527 48.7685L147.79 48.8045L147.621 47.0765L145.887 47.1051L145.725 45.3793L143.988 45.4153L143.826 43.6896L142.092 43.7181L141.922 41.9901L140.188 42.0186L140.026 40.2929L138.29 40.3289L138.128 38.6032L136.664 40.2433L138.958 42.2987Z",
    fill: "#EF484F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.692 78.0543C128.183 76.3785 125.001 70.7082 126.33 65.1834C124.794 64.7488 123.218 64.4985 121.634 64.4339L116.955 69.6836L113.173 71.1994L137.455 92.8645L137.475 92.8788L138.557 88.947L141.162 86.0268C141.314 83.325 140.932 80.6001 140.03 78.0277C138.032 78.6548 135.833 78.7055 133.692 78.0543Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.954 69.6835L121.634 64.4338L137.879 46.2231L138.958 42.2988L136.664 40.2433L135.582 44.1751L114.65 67.6332L110.869 69.149L113.173 71.1993L116.954 69.6835Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.954 69.6835L121.634 64.4338L137.879 46.2231L138.958 42.2988L136.664 40.2433L135.582 44.1751L114.65 67.6332L110.869 69.149L113.173 71.1993L116.954 69.6835Z",
    fill: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 42.2989L136.664 40.2434L138.958 42.2989Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 42.2989L136.664 40.2434L138.958 42.2989Z",
    fill: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 42.2989L136.664 40.2434L138.958 42.2989Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.958 42.2989L136.664 40.2434L138.958 42.2989Z",
    fill: "#D6D7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.692 78.0542C135.84 78.7076 138.03 78.6621 140.025 78.0425C143.339 77.0142 146.107 74.4214 147.193 70.8508C148.933 65.132 145.709 59.0891 139.99 57.3495C134.271 55.6099 128.228 58.8339 126.489 64.5528C126.425 64.7624 126.386 64.9713 126.33 65.1832C125.001 70.708 128.183 76.3783 133.692 78.0542ZM140.017 71.8328C140.115 72.1569 140.099 72.5038 139.987 72.8459C140.128 74.05 138.71 75.2953 136.739 75.6445C134.722 76.0122 132.909 75.3053 132.686 74.0761C132.613 73.6697 132.738 73.258 132.995 72.87C133.332 71.9255 134.38 71.034 135.794 70.6055C137.746 70.0217 139.632 70.5708 140.017 71.8328ZM136.345 59.52C136.825 59.4207 137.298 59.4502 137.736 59.6243C139.447 60.3166 139.962 63.0329 138.877 65.6877C138.721 66.0655 138.54 66.4193 138.348 66.7536C137.328 69.0032 135.411 70.3583 133.765 69.8573C131.886 69.2858 131.056 66.5308 131.909 63.699C132.682 61.1292 134.586 59.3859 136.345 59.52Z",
    fill: "#EF484F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.153 75.1732C135.2 75.757 133.305 75.2132 132.928 73.9535C132.822 73.6023 132.859 73.2375 132.988 72.8678C132.731 73.2558 132.606 73.6674 132.678 74.0739C132.901 75.3031 134.715 76.01 136.732 75.6422C138.697 75.2833 140.12 74.0477 139.979 72.8436C139.678 73.807 138.601 74.7389 137.153 75.1732Z",
    fill: "#E09C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.988 72.8677C132.861 73.2299 132.822 73.6022 132.928 73.9534C133.305 75.2131 135.198 75.7644 137.153 75.1731C138.601 74.7388 139.671 73.8046 139.979 72.8435C140.092 72.5015 140.105 72.1621 140.009 71.8305C139.632 70.5707 137.739 70.0194 135.784 70.6107C134.38 71.034 133.332 71.9255 132.988 72.8677Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.755 69.8627C135.409 70.3659 137.319 69.0085 138.338 66.759C137.151 68.7531 135.284 69.8371 133.822 69.2372C132.111 68.5449 131.596 65.8286 132.682 63.1738C133.488 61.1947 134.947 59.8146 136.342 59.5277C134.592 59.3958 132.68 61.1369 131.906 63.7066C131.046 66.5361 131.876 69.2912 133.755 69.8627Z",
    fill: "#E09C26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.674 63.1714C131.596 65.8285 132.104 68.5425 133.815 69.2348C135.286 69.8295 137.153 68.7455 138.331 66.7566C138.53 66.4246 138.711 66.0708 138.859 65.6907C139.937 63.0336 139.43 60.3196 137.719 59.6273C137.281 59.4532 136.808 59.4237 136.328 59.523C134.939 59.8122 133.481 61.1923 132.674 63.1714Z",
    fill: "#FAAC19"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.1073 72.5539C79.9837 72.4368 79.8745 72.3054 79.6977 72.1183C80.4598 70.7912 81.2177 69.4769 82.0069 68.0966C80.9253 67.1103 79.8251 66.1083 78.7206 65.1049L75.0203 67.5755C75.0203 67.5755 73.4377 68.4985 72.2512 67.3822C72.2512 67.3822 69.4271 65.1724 66.8154 67.697C66.8154 67.697 60.3966 73.854 61.9691 75.6509L61.9577 75.6853C65.4967 78.9083 69.0358 82.1313 72.5762 85.3499C73.7684 86.4347 74.7407 86.393 75.8498 85.1851C77.3743 83.5276 78.8945 81.8686 80.3917 80.1925C82.6468 77.6791 82.5307 74.8795 80.1073 72.5539Z",
    fill: "#51B95C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71 64.5755C92.0413 62.1404 89.1831 59.9909 86.0398 58.2863C83.9975 57.8558 81.9716 57.6215 82.0901 58.4189C82.0901 58.4189 82.6584 61.1054 81.3081 63.0445L79.6799 64.9444C80.5675 65.7523 81.4221 66.5302 82.2982 67.3296C82.5338 67.0925 82.7854 66.9227 82.9236 66.6917C83.6573 65.4505 84.6665 65.2684 85.9798 65.7112C86.9289 66.029 87.9447 66.1448 88.9608 66.3607C88.6564 67.486 88.2558 68.5413 88.0916 69.6318C87.6623 72.509 87.3333 75.4003 86.9684 78.2845C86.9544 78.3991 86.9019 78.5583 86.9566 78.624C87.2599 78.9911 87.589 79.3381 87.9123 79.688C88.1388 79.2906 88.5986 78.8652 88.546 78.5045C87.9921 74.4874 89.3117 70.9499 91.193 67.5311C91.4565 67.0505 91.7566 66.8347 92.29 67.0393C92.3445 67.062 92.4004 67.0662 92.4577 67.0803C94.1603 67.4273 94.1244 67.406 94.9762 65.9081C95.3252 65.2983 95.1208 64.9495 94.71 64.5755Z",
    fill: "#3FC7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7309 66.1301C97.2542 65.7248 96.7689 65.331 96.2002 64.8573C95.584 66.1038 95.0218 67.2442 94.4083 68.4821C95.7111 68.7545 96.9106 69.0071 98.0672 69.2456C98.1629 69.1579 98.2158 69.1277 98.2414 69.0789C99.2029 67.393 99.2072 67.3945 97.7309 66.1301Z",
    fill: "#54BA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0901 58.4187C81.9716 57.6213 84.0018 57.8571 86.0398 58.2861C84.8619 57.6496 83.6456 57.0719 82.3865 56.5659C81.9649 56.3982 81.5034 56.2937 81.0464 56.2478C80.1796 56.1574 79.983 56.4788 80.1388 57.3076C80.3456 58.4012 80.455 59.5151 80.5616 60.6234C80.6503 61.5111 80.3188 62.2411 79.6361 62.8362C79.2733 63.1552 78.9723 63.5472 78.5969 63.9623C78.9632 64.2977 79.3237 64.6217 79.6755 64.9429L81.3038 63.043C82.6584 61.1052 82.0901 58.4187 82.0901 58.4187Z",
    fill: "#0892C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8198 67.6984C69.4315 65.1739 72.2555 67.3836 72.2555 67.3836C73.4434 68.4956 75.0246 67.577 75.0246 67.577L78.725 65.1063C78.3731 64.7852 78.0169 64.4626 77.665 64.1414C76.5675 64.9097 75.4698 65.6492 74.4066 66.4288C73.9851 66.738 73.7101 66.7332 73.2951 66.3721C70.9268 64.2841 67.9827 64.4479 65.8472 66.7576C64.2813 68.4539 62.7341 70.166 61.1869 71.878C60.1435 73.0313 60.1911 74.0724 61.3215 75.0987C61.5341 75.2928 61.7509 75.4883 61.9635 75.6824L61.9749 75.648C60.401 73.8555 66.8198 67.6984 66.8198 67.6984Z",
    fill: "#00AE69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5634 78.823C62.0853 78.422 61.3765 78.4886 60.977 78.9625C60.977 78.9625 21.9564 125.266 22.6317 125.951C23.3601 126.692 62.7073 80.4109 62.7073 80.4109C63.104 79.9313 63.043 79.2196 62.5634 78.823Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.874 87.479C71.3958 87.078 70.6871 87.1446 70.2875 87.6185C70.2875 87.6185 31.2669 133.922 31.9422 134.607C32.6707 135.348 72.0178 89.0669 72.0178 89.0669C72.4145 88.5873 72.3493 87.8742 71.874 87.479Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4627 89.4655C59.187 89.2315 58.7689 89.27 58.5391 89.5471C58.5391 89.5471 35.8032 116.528 36.1954 116.929C36.6207 117.36 59.5486 90.3905 59.5486 90.3905C59.7783 90.1133 59.7384 89.6995 59.4627 89.4655Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0345 113.063C45.4598 113.494 68.3877 86.5245 68.3877 86.5245C68.6218 86.2488 68.5832 85.8307 68.3061 85.601C68.0304 85.3669 67.6123 85.4055 67.3825 85.6826C67.3782 85.6812 44.6409 112.666 45.0345 113.063Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2527 78.4883C58.4867 78.2126 58.4481 77.7945 58.171 77.5648C57.8939 77.3351 57.4772 77.3693 57.2475 77.6464C57.2475 77.6464 34.5115 104.627 34.9038 105.029C35.3248 105.458 58.2527 78.4883 58.2527 78.4883Z",
    fill: "url(#paint9_linear)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M172.219 82.8632C171.581 82.2543 170.564 82.2747 169.956 82.9119C169.956 82.9119 110.183 144.902 111.072 145.938C112.038 147.062 172.271 85.1339 172.271 85.1339C172.882 84.4908 172.862 83.4739 172.219 82.8632Z",
    fill: "url(#paint10_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.109 96.0622C179.474 95.4474 178.457 95.4678 177.84 96.1091C177.84 96.1091 117.973 158.006 118.862 159.041C119.822 160.163 180.15 98.3293 180.15 98.3293C180.767 97.688 180.744 96.677 180.109 96.0622Z",
    fill: "url(#paint11_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M187.423 100.061C187.053 99.7017 186.459 99.715 186.104 100.093C186.104 100.093 151.277 136.213 151.792 136.817C152.35 137.473 187.453 101.385 187.453 101.385C187.808 101.007 187.794 100.414 187.423 100.061Z",
    fill: "url(#paint12_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.037 121.502C146.481 122.02 174.289 93.4327 174.289 93.4327C174.574 93.1372 174.562 92.667 174.264 92.3885C173.969 92.1041 173.499 92.1162 173.22 92.4135C173.216 92.4058 145.624 121.026 146.037 121.502Z",
    fill: "url(#paint13_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M199.233 79.3401C199.322 79.4966 199.42 79.6431 199.522 79.7973C199.716 79.7334 199.91 79.6696 200.105 79.6058C200.034 79.5841 199.963 79.5624 199.893 79.5348C199.689 79.4597 199.457 79.4147 199.233 79.3401Z",
    fill: "#C42F49"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M196.803 79.4482C196.741 79.5458 196.671 79.6476 196.609 79.7453C196.585 79.7831 196.558 79.827 196.534 79.8648C196.391 80.2684 196.277 80.687 196.198 81.1164C196.626 80.923 197.124 80.7121 197.663 80.4943C197.577 80.3966 197.486 80.2911 197.407 80.1893C197.157 80.0095 196.95 79.7325 196.803 79.4482Z",
    fill: "#C42F49"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.568 70.0038C184.568 70.0038 192.594 66.8401 192.646 74.7665C192.956 74.8349 193.261 74.8957 193.571 74.9641C193.768 74.9531 193.972 74.9439 194.168 74.9389C194.101 74.9249 194.034 74.911 193.973 74.8988C193.984 74.8828 193.994 74.8728 193.987 74.8514C193.8 74.425 193.474 74.0472 193.227 73.6478C192.918 73.152 192.76 72.5856 192.525 72.0604C192.372 71.2233 192.459 70.3429 192.725 69.4911C189.224 66.2274 184.565 68.0141 184.565 68.0141C168.721 76.4002 175.966 88.2104 177.768 90.7358C175.586 85.3541 173.627 75.6285 184.568 70.0038Z",
    fill: "#BF1A46"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4 77.201C200.208 77.9074 201.244 78.3139 202.332 78.4838C201.038 77.1822 199.77 76.5818 198.688 76.349C198.879 76.6342 199.113 76.8869 199.338 77.1497C199.359 77.1628 199.38 77.1819 199.4 77.201Z",
    fill: "#C42F49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M194.834 77.8111C194.84 77.813 194.848 77.8088 194.848 77.8088C194.854 77.7655 194.861 77.7222 194.862 77.6771C194.785 77.6732 194.712 77.6575 194.64 77.6417L194.632 77.6458C194.62 77.6422 194.614 77.6404 194.602 77.6368C194.46 77.613 194.328 77.5792 194.195 77.5258C193.576 77.434 192.974 77.2829 192.385 77.1099C192.159 79.425 192.156 82.9616 194.457 81.9396C194.457 81.9396 194.633 81.8508 194.931 81.7019C194.914 81.6514 194.899 81.5949 194.882 81.5444C194.561 80.3647 194.499 79.0176 194.834 77.8111Z",
    fill: "#BF1A46"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M198.05 76.5693C197.974 76.9673 197.928 77.3743 197.939 77.7857C198.08 77.2782 198.232 76.7803 198.408 76.2896C198.315 76.2743 198.215 76.2632 198.128 76.2497C198.119 76.2794 198.11 76.309 198.099 76.3446C198.084 76.4175 198.066 76.4964 198.05 76.5693Z",
    fill: "#C42F49"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.547 80.2858C203.405 81.1693 204.319 82.1866 205.237 83.3215C205.237 83.3215 205.457 83.6608 205.616 84.2664C205.75 82.4025 204.746 80.9562 203.974 80.1313C203.875 80.1593 203.776 80.1874 203.68 80.2036C203.314 80.2797 202.932 80.2994 202.547 80.2858Z",
    fill: "#BF1A46"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M205.618 84.2604C205.453 83.653 205.239 83.3155 205.239 83.3155C204.321 82.1806 203.405 81.1692 202.549 80.2798C201.756 80.2454 200.949 80.0251 200.253 79.651C200.205 79.6366 200.158 79.6221 200.112 79.6017C199.918 79.6656 199.718 79.7276 199.529 79.7933C200.037 80.5701 200.677 81.2574 201.432 81.8181C201.58 81.928 201.732 82.0456 201.886 82.1573C201.938 82.1991 201.992 82.235 202.038 82.2749C202.176 82.3753 202.314 82.4756 202.452 82.5759C202.504 82.6177 202.563 82.6554 202.617 82.6912C202.751 82.7838 202.885 82.8764 203.02 82.9631C203.074 82.999 203.122 83.033 203.178 83.0629C203.347 83.1664 203.522 83.2716 203.697 83.3573C204.233 83.6375 204.799 83.8424 205.395 83.8878C205.342 83.8911 205.297 83.8903 205.269 83.895C204.546 83.9921 203.915 84.0005 203.196 83.8525C202.226 83.6541 201.332 83.1675 200.493 82.6657C199.627 82.149 198.496 81.3961 197.677 80.4724C197.137 80.6902 196.639 80.901 196.211 81.0944C195.978 82.3453 196.03 83.6632 196.377 84.8834C196.296 84.7679 196.222 84.6483 196.143 84.5268C196.136 84.5054 196.13 84.484 196.117 84.4608C195.593 83.5883 195.212 82.5846 194.95 81.6818C194.646 81.8288 194.475 81.9195 194.475 81.9195C192.169 82.9397 192.176 79.4108 192.404 77.0898C191.418 76.7957 190.465 76.3949 189.535 75.8524C188.606 75.3099 187.818 74.6226 187.103 73.8216C186.742 73.4134 186.461 72.9521 186.196 72.4826C186.048 72.2237 185.701 71.7485 185.61 71.3646C185.682 71.4059 185.754 71.4472 185.83 71.4962C185.83 71.4962 185.828 71.5021 185.834 71.5039C186.314 71.8189 186.79 72.2555 187.199 72.5292C188.029 73.0802 188.923 73.5276 189.842 73.9116C190.768 74.2974 191.705 74.5378 192.653 74.7427C192.601 66.8163 184.575 69.98 184.575 69.98C173.633 75.6106 175.591 85.3363 177.783 90.7079C178.01 91.0235 178.152 91.1962 178.152 91.1962C178.33 91.419 178.518 91.6318 178.711 91.8267C178.837 91.9686 178.958 92.1223 179.093 92.254C184.783 98.1351 194.042 98.5153 200.559 93.5636C206.078 89.3827 206.048 85.8685 205.618 84.2604Z",
    fill: "#EA1E5C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M178.7 91.8427C178.509 91.6418 178.319 91.435 178.141 91.2122C178.325 91.4368 178.516 91.6376 178.7 91.8427Z",
    fill: "#EF4537"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M204.315 69.8757C204.394 69.958 204.471 70.0462 204.547 70.1344C204.471 70.0462 204.394 69.958 204.315 69.8757Z",
    fill: "#109C49"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194.323 74.9602C194.207 74.9377 194.092 74.8897 193.989 74.8453C193.995 74.8667 193.992 74.8786 193.974 74.8927C194.041 74.9067 194.108 74.9206 194.17 74.9328C193.966 74.942 193.768 74.953 193.572 74.958C193.261 74.8955 192.951 74.827 192.648 74.7604C191.7 74.5555 190.756 74.3133 189.837 73.9293C188.917 73.5453 188.023 73.0979 187.194 72.5469C186.785 72.2733 186.303 71.8348 185.828 71.5217C185.87 72.0656 186.343 72.5532 186.725 72.9158C187.681 73.8164 188.767 74.549 189.942 75.1342C191.124 75.7211 192.532 76.3317 193.854 76.4563C194.271 76.4926 195.271 76.4217 195.358 76.9859C195.411 77.3002 195.011 77.5281 194.653 77.6393C194.728 77.6491 194.801 77.6649 194.876 77.6747C194.869 77.718 194.862 77.7613 194.861 77.8064C194.855 77.8046 194.848 77.8088 194.848 77.8088C194.512 79.0152 194.575 80.3623 194.909 81.5397C194.926 81.5902 194.941 81.6467 194.958 81.6972C195.225 82.6078 195.601 83.6037 196.126 84.4762C195.71 83.4813 195.492 82.4107 195.558 81.323C195.603 80.6239 195.781 79.9332 196.1 79.3114C196.298 78.9181 196.761 78.2043 197.284 78.3182C197.034 78.7991 196.777 79.2586 196.629 79.7447C196.691 79.647 196.755 79.5434 196.823 79.4475C196.969 79.7319 197.172 80.0011 197.428 80.1827C197.507 80.2846 197.598 80.39 197.685 80.4878C198.505 81.4115 199.636 82.1644 200.502 82.6812C201.34 83.1829 202.237 83.6636 203.204 83.8679C203.924 84.016 204.555 84.0075 205.278 83.9104C205.305 83.9058 205.35 83.9066 205.403 83.9032C204.802 83.856 204.242 83.6529 203.705 83.3727C203.721 83.3841 203.739 83.3895 203.755 83.4008C203.456 83.3419 203.16 83.2712 202.867 83.1885C201.716 82.8635 200.635 82.2229 199.809 81.3621C198.598 80.1054 197.979 77.9925 198.446 76.2494C198.442 76.2613 198.439 76.2731 198.435 76.285C198.259 76.7757 198.108 77.2736 197.966 77.7811C197.957 77.3638 198.002 76.9627 198.078 76.5648C198.064 76.6318 198.048 76.7047 198.034 76.7717C197.837 74.2499 199.421 71.9016 201.711 70.8505C202.353 70.5536 202.987 70.598 203.663 70.5256C204.011 70.4892 204.246 70.2302 204.292 69.8879C204.293 69.8624 204.293 69.8428 204.292 69.8232C203.938 69.4756 203.501 69.2517 202.914 69.3511C202.352 69.4519 201.749 69.7282 201.247 70.0999C201.034 70.2877 200.836 70.4928 200.651 70.6956C200.227 71.0653 199.825 71.4482 199.457 71.8929C199.017 72.4198 198.592 72.964 198.195 73.5232C197.599 74.3521 196.816 75.4545 195.712 75.1439C195.766 75.115 195.832 75.0898 195.865 75.087C196.363 75.0702 196.784 74.7711 197.153 74.3911C197.063 74.3895 196.973 74.3879 196.876 74.3649C196.582 74.3078 196.362 74.1175 196.139 73.9331C196.093 73.8931 196.053 73.8549 196.009 73.809C196.007 73.815 196.001 73.8131 195.999 73.8191C195.967 73.7964 195.941 73.7755 195.911 73.7469L195.925 73.7445C195.938 73.7422 195.944 73.744 195.95 73.7458C193.801 71.5097 194.331 67.5381 196.695 65.5441C196.871 65.3905 197.062 65.2543 197.237 65.1066C197.148 65.0795 197.065 65.0738 196.983 65.0877C195.483 65.9714 194.448 67.6644 193.852 69.2383C193.135 71.0996 193.278 73.268 194.323 74.9602Z",
    fill: "#00AE69"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.637 77.6472L194.645 77.6432C194.633 77.6397 194.62 77.6419 194.608 77.6384C194.62 77.6419 194.631 77.6455 194.637 77.6472Z",
    fill: "#C42F49"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M194.637 77.6472L194.645 77.6432C194.633 77.6397 194.62 77.6419 194.608 77.6384C194.62 77.6419 194.631 77.6455 194.637 77.6472Z",
    fill: "#109C49"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.818 71.5122C185.749 71.465 185.671 71.4219 185.599 71.3806C185.671 71.4219 185.745 71.4768 185.817 71.5181C185.823 71.5199 185.817 71.5181 185.818 71.5122Z",
    fill: "#EF4537"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M185.818 71.5122C185.749 71.465 185.671 71.4219 185.599 71.3806C185.671 71.4219 185.745 71.4768 185.817 71.5181C185.823 71.5199 185.817 71.5181 185.818 71.5122Z",
    fill: "#109C49"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M194.608 77.6386C194.62 77.6423 194.633 77.6399 194.645 77.6436C195.005 77.5264 195.403 77.3044 195.35 76.9902C195.257 76.4241 194.263 76.4968 193.846 76.4605C192.524 76.3359 191.11 75.7236 189.935 75.1384C188.759 74.5532 187.674 73.8207 186.717 72.9201C186.335 72.5575 185.862 72.0698 185.821 71.5259C185.745 71.4769 185.677 71.4238 185.603 71.3884C185.694 71.7723 186.047 72.2493 186.189 72.5064C186.454 72.9759 186.733 73.4431 187.096 73.8454C187.805 74.6445 188.599 75.3337 189.528 75.8762C190.456 76.4246 191.411 76.8195 192.397 77.1135C192.985 77.2865 193.587 77.4376 194.207 77.5294C194.334 77.581 194.472 77.6167 194.608 77.6386Z",
    fill: "#109C49"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.608 77.6386C194.62 77.6423 194.633 77.6399 194.645 77.6436C195.005 77.5264 195.403 77.3044 195.35 76.9902C195.257 76.4241 194.263 76.4968 193.846 76.4605C192.524 76.3359 191.11 75.7236 189.935 75.1384C188.759 74.5532 187.674 73.8207 186.717 72.9201C186.335 72.5575 185.862 72.0698 185.821 71.5259C185.745 71.4769 185.677 71.4238 185.603 71.3884C185.694 71.7723 186.047 72.2493 186.189 72.5064C186.454 72.9759 186.733 73.4431 187.096 73.8454C187.805 74.6445 188.599 75.3337 189.528 75.8762C190.456 76.4246 191.411 76.8195 192.397 77.1135C192.985 77.2865 193.587 77.4376 194.207 77.5294C194.334 77.581 194.472 77.6167 194.608 77.6386Z",
    fill: "#109C49"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M198.426 76.2304C198.424 76.2364 198.42 76.2482 198.419 76.2541C198.448 76.1789 198.466 76.1 198.495 76.0248C198.473 76.0959 198.447 76.1593 198.426 76.2304Z",
    fill: "#109C49"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M199.782 81.3667C200.608 82.2275 201.689 82.868 202.84 83.1931C203.132 83.2757 203.43 83.3406 203.728 83.4054C203.712 83.3941 203.694 83.3887 203.678 83.3773C203.505 83.2857 203.328 83.1864 203.159 83.0829C203.105 83.0471 203.051 83.0112 203.001 82.9831C202.866 82.8964 202.732 82.8038 202.598 82.7112C202.544 82.6754 202.486 82.6318 202.433 82.5959C202.295 82.4956 202.157 82.3953 202.019 82.2949C201.967 82.2531 201.913 82.2173 201.867 82.1773C201.715 82.0597 201.561 81.948 201.413 81.8381C200.658 81.2774 200.018 80.5901 199.51 79.8133C199.414 79.6609 199.31 79.5126 199.222 79.3561C199.441 79.423 199.674 79.4679 199.884 79.5448C199.953 79.5725 200.024 79.5941 200.095 79.6158C200.143 79.6303 200.188 79.6507 200.236 79.6651C200.931 80.0392 201.739 80.2595 202.532 80.2939C202.915 80.3134 203.298 80.2878 203.665 80.2117C203.762 80.1895 203.86 80.1674 203.959 80.1394C204.702 79.932 205.487 79.5039 205.896 78.8445C206.137 78.458 206.452 77.8284 206.445 77.2757C205.699 78.2987 204.234 78.6424 202.981 78.565C202.759 78.5492 202.541 78.5215 202.318 78.4861C201.23 78.3162 200.194 77.9097 199.386 77.2033C199.366 77.1842 199.346 77.1651 199.326 77.1461C199.101 76.8833 198.873 76.6324 198.676 76.3454C198.653 76.3126 198.623 76.284 198.603 76.2453C198.56 76.1739 198.516 76.1025 198.483 76.021C198.454 76.0963 198.43 76.1733 198.407 76.2504C197.954 77.9911 198.571 80.11 199.782 81.3667Z",
    fill: "#109C49"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M199.782 81.3667C200.608 82.2275 201.689 82.868 202.84 83.1931C203.132 83.2757 203.43 83.3406 203.728 83.4054C203.712 83.3941 203.694 83.3887 203.678 83.3773C203.505 83.2857 203.328 83.1864 203.159 83.0829C203.105 83.0471 203.051 83.0112 203.001 82.9831C202.866 82.8964 202.732 82.8038 202.598 82.7112C202.544 82.6754 202.486 82.6318 202.433 82.5959C202.295 82.4956 202.157 82.3953 202.019 82.2949C201.967 82.2531 201.913 82.2173 201.867 82.1773C201.715 82.0597 201.561 81.948 201.413 81.8381C200.658 81.2774 200.018 80.5901 199.51 79.8133C199.414 79.6609 199.31 79.5126 199.222 79.3561C199.441 79.423 199.674 79.4679 199.884 79.5448C199.953 79.5725 200.024 79.5941 200.095 79.6158C200.143 79.6303 200.188 79.6507 200.236 79.6651C200.931 80.0392 201.739 80.2595 202.532 80.2939C202.915 80.3134 203.298 80.2878 203.665 80.2117C203.762 80.1895 203.86 80.1674 203.959 80.1394C204.702 79.932 205.487 79.5039 205.896 78.8445C206.137 78.458 206.452 77.8284 206.445 77.2757C205.699 78.2987 204.234 78.6424 202.981 78.565C202.759 78.5492 202.541 78.5215 202.318 78.4861C201.23 78.3162 200.194 77.9097 199.386 77.2033C199.366 77.1842 199.346 77.1651 199.326 77.1461C199.101 76.8833 198.873 76.6324 198.676 76.3454C198.653 76.3126 198.623 76.284 198.603 76.2453C198.56 76.1739 198.516 76.1025 198.483 76.021C198.454 76.0963 198.43 76.1733 198.407 76.2504C197.954 77.9911 198.571 80.11 199.782 81.3667Z",
    fill: "#109C49"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.636 70.5303C202.96 70.6027 202.325 70.5583 201.684 70.8552C199.4 71.9081 197.812 74.2487 198.007 76.7764C198.015 76.7076 198.036 76.6364 198.05 76.5694C198.066 76.4965 198.076 76.4217 198.099 76.3447C198.108 76.315 198.117 76.2854 198.128 76.2498C198.157 76.1354 198.189 76.0287 198.223 75.9161C198.24 75.8627 198.258 75.8035 198.274 75.7501C198.34 75.5563 198.417 75.3661 198.5 75.1777C198.521 75.1321 198.547 75.0883 198.567 75.0427C198.636 74.9017 198.707 74.7548 198.782 74.6157C198.821 74.5499 198.853 74.4884 198.893 74.4226C198.962 74.3013 199.035 74.1876 199.111 74.0681C199.156 74.0042 199.196 73.9384 199.241 73.8745C199.322 73.7568 199.41 73.6408 199.498 73.5189C199.54 73.4669 199.576 73.413 199.618 73.361C199.753 73.1948 199.886 73.0345 200.031 72.8779C200.232 72.706 200.45 72.5456 200.669 72.3987C200.685 72.3905 200.712 72.3859 200.747 72.3771C200.795 72.3465 200.842 72.3217 200.882 72.2952C201.693 71.8234 202.522 71.4863 203.46 71.3837C204.15 71.309 205.701 71.7884 204.842 70.5286C204.764 70.4208 204.689 70.3071 204.604 70.2034C204.586 70.1784 204.567 70.1534 204.549 70.1284C204.474 70.0342 204.395 69.952 204.317 69.8697C204.303 69.8524 204.289 69.8352 204.267 69.822C204.267 69.8416 204.266 69.8671 204.266 69.8867C204.218 70.2349 203.984 70.4939 203.636 70.5303Z",
    fill: "#109C49"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M203.636 70.5303C202.96 70.6027 202.325 70.5583 201.684 70.8552C199.4 71.9081 197.812 74.2487 198.007 76.7764C198.015 76.7076 198.036 76.6364 198.05 76.5694C198.066 76.4965 198.076 76.4217 198.099 76.3447C198.108 76.315 198.117 76.2854 198.128 76.2498C198.157 76.1354 198.189 76.0287 198.223 75.9161C198.24 75.8627 198.258 75.8035 198.274 75.7501C198.34 75.5563 198.417 75.3661 198.5 75.1777C198.521 75.1321 198.547 75.0883 198.567 75.0427C198.636 74.9017 198.707 74.7548 198.782 74.6157C198.821 74.5499 198.853 74.4884 198.893 74.4226C198.962 74.3013 199.035 74.1876 199.111 74.0681C199.156 74.0042 199.196 73.9384 199.241 73.8745C199.322 73.7568 199.41 73.6408 199.498 73.5189C199.54 73.4669 199.576 73.413 199.618 73.361C199.753 73.1948 199.886 73.0345 200.031 72.8779C200.232 72.706 200.45 72.5456 200.669 72.3987C200.685 72.3905 200.712 72.3859 200.747 72.3771C200.795 72.3465 200.842 72.3217 200.882 72.2952C201.693 71.8234 202.522 71.4863 203.46 71.3837C204.15 71.309 205.701 71.7884 204.842 70.5286C204.764 70.4208 204.689 70.3071 204.604 70.2034C204.586 70.1784 204.567 70.1534 204.549 70.1284C204.474 70.0342 204.395 69.952 204.317 69.8697C204.303 69.8524 204.289 69.8352 204.267 69.822C204.267 69.8416 204.266 69.8671 204.266 69.8867C204.218 70.2349 203.984 70.4939 203.636 70.5303Z",
    fill: "#109C49"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M204.267 69.822C204.267 69.822 204.265 69.828 204.267 69.822C204.281 69.8393 204.301 69.8585 204.315 69.8758C204.301 69.8585 204.287 69.8412 204.267 69.822Z",
    fill: "#109C49"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M204.267 69.822C204.267 69.822 204.265 69.828 204.267 69.822C204.281 69.8393 204.301 69.8585 204.315 69.8758C204.301 69.8585 204.287 69.8412 204.267 69.822Z",
    fill: "#109C49"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M198.128 76.2498C198.157 76.1354 198.189 76.0287 198.224 75.916C198.183 76.0269 198.155 76.1413 198.128 76.2498Z",
    fill: "#109C49"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M198.128 76.2498C198.157 76.1354 198.189 76.0287 198.224 75.916C198.183 76.0269 198.155 76.1413 198.128 76.2498Z",
    fill: "#109C49"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M196.609 79.7452C196.585 79.7831 196.558 79.8269 196.534 79.8648C196.558 79.8269 196.585 79.7831 196.609 79.7452Z",
    fill: "#C42F49"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M196.609 79.7452C196.585 79.7831 196.558 79.8269 196.534 79.8648C196.558 79.8269 196.585 79.7831 196.609 79.7452Z",
    fill: "#109C49"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M196.135 84.5506C196.209 84.6703 196.289 84.7917 196.37 84.9072C196.274 84.7744 196.196 84.6275 196.11 84.4846C196.118 84.5001 196.123 84.5274 196.135 84.5506Z",
    fill: "#EF4537"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M196.135 84.5506C196.209 84.6703 196.289 84.7917 196.37 84.9072C196.274 84.7744 196.196 84.6275 196.11 84.4846C196.118 84.5001 196.123 84.5274 196.135 84.5506Z",
    fill: "#109C49"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M196.534 79.8647C196.558 79.8268 196.585 79.783 196.609 79.7451C196.751 79.2572 197.008 78.7978 197.264 78.3187C196.742 78.2048 196.278 78.9186 196.08 79.3118C195.767 79.9355 195.583 80.6244 195.538 81.3234C195.472 82.4112 195.69 83.4818 196.106 84.4767C196.192 84.6195 196.27 84.7665 196.366 84.8993C196.019 83.6791 195.967 82.3611 196.199 81.1103C196.277 80.6868 196.391 80.2683 196.534 79.8647Z",
    fill: "#109C49"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M196.534 79.8647C196.558 79.8268 196.585 79.783 196.609 79.7451C196.751 79.2572 197.008 78.7978 197.264 78.3187C196.742 78.2048 196.278 78.9186 196.08 79.3118C195.767 79.9355 195.583 80.6244 195.538 81.3234C195.472 82.4112 195.69 83.4818 196.106 84.4767C196.192 84.6195 196.27 84.7665 196.366 84.8993C196.019 83.6791 195.967 82.3611 196.199 81.1103C196.277 80.6868 196.391 80.2683 196.534 79.8647Z",
    fill: "#109C49"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M193.229 73.6418C193.47 74.0393 193.801 74.4189 193.989 74.8454C194.098 74.8916 194.207 74.9377 194.323 74.9602C193.272 73.2662 193.13 71.0978 193.836 69.2466C194.439 67.6745 195.467 65.9797 196.968 65.096C196.88 65.1081 196.798 65.1415 196.717 65.1946C196.217 65.4761 195.715 65.7831 195.265 66.1319C194.335 66.846 193.41 67.756 192.946 68.8521C192.857 69.0582 192.792 69.2716 192.727 69.485C192.467 70.3386 192.38 71.2191 192.527 72.0544C192.768 72.5813 192.926 73.1477 193.229 73.6418Z",
    fill: "#109C49"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M193.229 73.6418C193.47 74.0393 193.801 74.4189 193.989 74.8454C194.098 74.8916 194.207 74.9377 194.323 74.9602C193.272 73.2662 193.13 71.0978 193.836 69.2466C194.439 67.6745 195.467 65.9797 196.968 65.096C196.88 65.1081 196.798 65.1415 196.717 65.1946C196.217 65.4761 195.715 65.7831 195.265 66.1319C194.335 66.846 193.41 67.756 192.946 68.8521C192.857 69.0582 192.792 69.2716 192.727 69.485C192.467 70.3386 192.38 71.2191 192.527 72.0544C192.768 72.5813 192.926 73.1477 193.229 73.6418Z",
    fill: "#109C49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 84.5,
    y1: 133.5,
    x2: 135.839,
    y2: 129.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 67,
    y1: 117,
    x2: 122.173,
    y2: 106.991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 102.61,
    y1: 104.46,
    x2: 112.818,
    y2: 110.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 94.5965,
    y1: 104.534,
    x2: 104.805,
    y2: 110.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 88.0696,
    y1: 91.4974,
    x2: 98.2779,
    y2: 97.3873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 35.1964,
    y1: 101.082,
    x2: 48.747,
    y2: 107.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 44.5063,
    y1: 109.738,
    x2: 58.057,
    y2: 116.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 43.5142,
    y1: 102.434,
    x2: 51.4104,
    y2: 106.442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 52.3551,
    y1: 98.568,
    x2: 60.2513,
    y2: 102.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 42.2237,
    y1: 90.5298,
    x2: 50.1198,
    y2: 94.5373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 131.269,
    y1: 111.766,
    x2: 149.842,
    y2: 122.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 139.16,
    y1: 124.979,
    x2: 157.716,
    y2: 136.055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0825,
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1887,
    stopColor: "#EE3892",
    stopOpacity: 0.1643
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2932,
    stopColor: "#EE388D",
    stopOpacity: 0.3257
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3969,
    stopColor: "#EE3984",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4996,
    stopColor: "#EE397A",
    stopOpacity: 0.6447
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6001,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 163.556,
    y1: 116.86,
    x2: 174.379,
    y2: 123.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 155.356,
    y1: 105.676,
    x2: 163.931,
    y2: 110.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED3895",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.084,
    stopColor: "#EE3891",
    stopOpacity: 0.1423
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1866,
    stopColor: "#EE388B",
    stopOpacity: 0.3163
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2989,
    stopColor: "#EE3981",
    stopOpacity: 0.5066
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4174,
    stopColor: "#EE3A73",
    stopOpacity: 0.7074
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#EE3B6C",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3E841"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "white",
    transform: "translate(49.1821) rotate(16.9189)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.8284,
    height: 97.8284,
    fill: "white",
    transform: "translate(29.6477 35) rotate(18.257)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDontblink);
export default __webpack_public_path__ + "static/media/dontblink.68f784441f305446191e1bc3c27e9cd0.svg";
export { ForwardRef as ReactComponent };